import * as TYPES from './type';
export default {
  //授课测试
  [TYPES.SK_TEST_LIST](state, { result }) {
    state.SKTestList = result.result
  },
  //测试详情
  [TYPES.SK_TEST_DETAILS](state, { result }) {
    state.SKTestDetails = result.result
  },
  //测试结束
  [TYPES.SK_TESTT_END](state, { result }) {
    state.SKTestEnd = result.result
  },
  //测试推送
  [TYPES.SK_TESTT_EDIT](state, { result }) {
    state.SKTestEdit = result.result
  },
}



// WEBPACK FOOTER //
// ./src/store/give-course/test/mutations.js